export const AUTH_ERROR_MESSAGES = [
  'Token expired or invalid',
  'Missing ID Token',
];

/**
 * Rejection message used after a token is renewed following an
 * UnauthorizedException, signalling the query should be retried with the fresh
 * token. Intentionally NOT in AUTH_ERROR_MESSAGES so the retry guard allows it.
 */
export const AUTH_RENEWED_RETRY_MESSAGE = 'Token renewed, retrying';
